import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowBottomRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-bottom-right, resize small, box, arrow"><path d="M20.25 9.25V3.75L3.75 3.75L3.75 20.25H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 13.75V20.25H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.5657 19.5657L11 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowBottomRight;
